/*
If url parameters are null or undefined, conType should default to P.
*/
const getConType = (utmSource, utmContent) => {
  if (utmSource === 'newsletter') {
    // don't parse utmContent if null or undefined
    // expected shape of utmContent: [Letter]_[Date]. e.g. "C_30_2021-01"
    if (utmContent && utmContent.charAt(0) === 'C') {
      return 'C';
    }
    return 'P';
  }
  return 'P';
};

export default getConType;
